import DefaultIcon from '@upright/ui/icons/img/streamline-mini-line/programming/script/programming-script-2.svg';
import GreenFactory from '@upright/ui/icons/img/streamline-regular/ecology/renewable-energy/renewable-energy-earth.svg';
import FloodWall from '@upright/ui/icons/img/streamline-regular/ecology/renewable-energy/renewable-energy-water-dam.svg';
import WaterProtectionFish from '@upright/ui/icons/img/streamline-regular/ecology/water-protection/water-protection-fish.svg';
import RecyclingSign from '@upright/ui/icons/img/streamline-regular/ecology/recycling/recycling-sign.svg';
import WildLifeProtectionSign from '@upright/ui/icons/img/streamline-regular/ecology/wildlife-protection/wildlife-protection-tree-shield-1.svg';
import AirPurifier from '@upright/ui/icons/img/streamline-regular/ecology/pollution/air-purifier-1.svg';
import { EuObjectives } from '@upright/common/model/input/eu-taxonomy/types';

export function getEuObjectiveIcon(objective: EuObjectives) {
  switch (objective) {
    case EuObjectives.mitigation:
      return GreenFactory;
    case EuObjectives.adaptation:
      return FloodWall;
    case EuObjectives.water:
      return WaterProtectionFish;
    case EuObjectives.circular:
      return RecyclingSign;
    case EuObjectives.biodiversity:
      return WildLifeProtectionSign;
    case EuObjectives.pollution:
      return AirPurifier;
    default:
      return DefaultIcon;
  }
}
